import React from 'react';

const PdfSvg = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width='25'
			height='32'
			viewBox='0 0 25 32'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}>
			<path
				d='M0 4.00002C0 1.79088 1.79086 1.52588e-05 4 1.52588e-05H16L24.4211 8.42107V28C24.4211 30.2092 22.6302 32 20.4211 32H4C1.79086 32 0 30.2092 0 28V4.00002Z'
				fill='#FF4D4F'
			/>
			<path
				d='M16.0001 1.40876e-05L16.0001 4.42107C16.0001 6.63021 17.791 8.42107 20.0001 8.42107L24.4211 8.42107L16.0001 1.40876e-05Z'
				fill='#CF1322'
			/>
			<path
				d='M16.5554 14.3158H20.5189L20.5146 15.1051H17.4905V17.0225H20.18V17.8031H17.4905V20.5184H16.5554V14.3158Z'
				fill='white'
			/>
			<path
				d='M10.5486 14.3158C10.5715 14.3158 10.6387 14.3172 10.7502 14.3201C10.8646 14.3201 11.0018 14.3201 11.162 14.3201C11.3221 14.3172 11.4851 14.3172 11.651 14.3201C11.8197 14.3201 11.9698 14.3215 12.1014 14.3244C12.8592 14.3358 13.4754 14.4616 13.9501 14.7019C14.4248 14.9421 14.7723 15.2881 14.9925 15.7399C15.2155 16.1889 15.327 16.7365 15.327 17.3828C15.327 18.0548 15.2084 18.6253 14.971 19.0943C14.7337 19.5604 14.3705 19.915 13.8815 20.158C13.3954 20.3983 12.7791 20.5184 12.0327 20.5184H10.5486V14.3158ZM11.4837 15.0879V19.7463H12.0413C12.5103 19.7463 12.9178 19.6705 13.2638 19.5189C13.6127 19.3645 13.8829 19.1157 14.0745 18.7725C14.2661 18.4265 14.3619 17.9647 14.3619 17.3871C14.3619 16.8208 14.2704 16.3705 14.0874 16.0359C13.9044 15.6984 13.6413 15.4568 13.2981 15.311C12.9578 15.1623 12.5475 15.0879 12.0671 15.0879H11.4837Z'
				fill='white'
			/>
			<path
				d='M5.05273 20.5184V14.3158H7.20175C7.645 14.3158 8.04106 14.3916 8.38993 14.5431C8.74167 14.6947 9.01762 14.9178 9.2178 15.2123C9.42083 15.5068 9.52235 15.8686 9.52235 16.2975C9.52235 16.7093 9.42941 17.0611 9.24353 17.3527C9.06052 17.6416 8.80315 17.8632 8.47143 18.0176C8.14257 18.1692 7.76081 18.2449 7.32615 18.2449H5.98784V20.5184H5.05273ZM5.98355 17.4943H7.30041C7.69504 17.4943 8.01675 17.3813 8.26554 17.1554C8.51432 16.9267 8.63872 16.6235 8.63872 16.2461C8.63872 15.8629 8.51004 15.5698 8.25267 15.3667C7.9953 15.1608 7.66644 15.0579 7.26609 15.0579H5.98355V17.4943Z'
				fill='white'
			/>
		</svg>
	);
};

export default PdfSvg;
